// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-course-characteristics--search {\n  border-radius: 3px;\n  width: 100%;\n  padding: 8px;\n  border-style: solid;\n  border-color: #949596;\n  border-width: 1px; }\n", ""]);
// Exports
module.exports = exports;
